import { useAuth } from "@/context/AuthContext";

export default function Placeholder({ title }) {
  const { studio } = useAuth();
  return (
    <div className="space-y-4">
      <h1 className="font-display text-2xl md:text-3xl font-bold text-[#27272A]">{title}</h1>
      <div className="card-nc p-8 text-center">
        <p className="text-[#71717A]">Este módulo estará disponível em breve para {studio?.name || "seu studio"}.</p>
        <p className="text-xs text-[#71717A] mt-2">Ele está previsto no roadmap e será liberado nas próximas fases.</p>
      </div>
    </div>
  );
}
